/**
 * Flatten /models/ollama/ families into a sorted list (installed first, then name).
 */
export function flattenOllamaFamilies(families) {
    if (!Array.isArray(families)) return [];
    const flat = families.flatMap((fam) =>
        (fam.models || []).map((m) => ({
            ...m,
            familyName: fam.name,
            familyDescription: fam.description,
            familyIcon: fam.icon,
            fullName: m.name,
            installed: !!m.installed,
        })),
    );
    return flat.sort((a, b) => {
        if (a.installed !== b.installed) return (b.installed ? 1 : 0) - (a.installed ? 1 : 0);
        return (a.fullName || '').localeCompare(b.fullName || '', undefined, { sensitivity: 'base' });
    });
}
